'use client'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import FactBlock from './FactBlock'
import FactsSection from './FactsSection'

const NonPaymentsSafetySection = () => {
  const translate = useTranslate('trust_and_safety')

  return (
    <>
      <FactsSection>
        <FactBlock
          icon="anti-spam"
          title={translate('anti_spam_title')}
          body={translate('anti_spam_body')}
        />
        <FactBlock
          icon="safe"
          title={translate('safe_payments_title')}
          body={translate('safe_payments_body')}
        />
      </FactsSection>
      <FactsSection>
        <FactBlock
          icon="support"
          title={translate('support_title')}
          body={translate('support_body')}
        />
        <FactBlock
          icon="secure"
          title={translate('secure_data_title')}
          body={translate('secure_data_body')}
        />
      </FactsSection>
    </>
  )
}

export default NonPaymentsSafetySection
